import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { computed, inject, Injectable, InjectionToken, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const INIT_MOBILE = new InjectionToken<boolean>('initMobile');

export enum ViewPort {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    DESKTOP = 'desktop',
}

@Injectable({
    providedIn: 'root',
})
export class ViewportDetectionService {
    breakpointObserver = inject(BreakpointObserver);
    platformId = inject(PLATFORM_ID);
    initMobile = inject(INIT_MOBILE, { optional: true });

    private readonly BREAKPOINT_DESKTOP = '(min-width: 1024px)';
    private readonly BREAKPOINT_TABLET = '(min-width: 768px) and (max-width: 1023px)';
    private readonly BREAKPOINT_LG = '(min-width: 1024px) and (max-width: 1280px)';

    isMobile = signal(true);
    isTablet = signal(true);
    isLgSubject = signal(true);

    viewPort = computed(() => {
        if (this.isTablet()) {
            return ViewPort.TABLET;
        }
        if (this.isMobile()) {
            return ViewPort.MOBILE;
        }

        return ViewPort.DESKTOP;
    });

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            this.breakpointObserver
                .observe([this.BREAKPOINT_DESKTOP, this.BREAKPOINT_TABLET, this.BREAKPOINT_LG])
                .pipe(takeUntilDestroyed())
                .subscribe(() => {
                    this.matchingFunctions();
                });
        } else {
            this.isMobile.set(this.initMobile ?? false);
            this.isTablet.set(!this.initMobile);
            this.isLgSubject.set(!this.initMobile);
        }
    }

    matchingFunctions() {
        this.isMobile.set(
            !this.breakpointObserver.isMatched(this.BREAKPOINT_DESKTOP) &&
                !this.breakpointObserver.isMatched(this.BREAKPOINT_TABLET),
        );
        this.isTablet.set(this.breakpointObserver.isMatched(this.BREAKPOINT_TABLET));
        this.isLgSubject.set(this.breakpointObserver.isMatched(this.BREAKPOINT_LG));
    }
}
